// Platform-agnostic formatting helpers (ru-RU locale).
import { DATE_RE } from './date'

export function fmtDate(iso: string): string {
  const d = new Date(iso)
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })
}

export function timeAgo(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime()
  const min = Math.floor(diff / 60000)
  if (min < 1) return 'только что'
  if (min < 60) return `${min} ${pluralRu(min, 'минуту', 'минуты', 'минут')} назад`
  const h = Math.floor(min / 60)
  if (h < 24) return `${h} ${pluralRu(h, 'час', 'часа', 'часов')} назад`
  const d = Math.floor(h / 24)
  if (d < 30) return `${d} ${pluralRu(d, 'день', 'дня', 'дней')} назад`
  return fmtDate(iso)
}

/** «Gürcüstan» ≈ «gurc»: без регистра и диакритики; у ə и ı нет NFD-разложения — заменяем явно. */
export const fold = (s: string) =>
  s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/ə/g, 'e').replace(/ı/g, 'i')

/** Russian plural selector. */
export function pluralRu(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return one
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few
  return many
}

/** Inclusive day count between two ISO dates. */
export function daysInclusive(startIso: string, endIso: string): number {
  const a = new Date(startIso).getTime()
  const b = new Date(endIso).getTime()
  return Math.round((b - a) / 86400000) + 1
}

/** Число без хвостовых нулей: 8 → «8», 7.5 → «7.5». Не-число → «—». */
export function fmtNum(n: number, digits = 1): string {
  if (!Number.isFinite(n)) return '—'
  return Number.isInteger(n) ? String(n) : n.toFixed(digits)
}

/** ISO-дата/таймстамп → `YYYY-MM-DD` (пусто, если значения нет). */
export const ymd10 = (v?: string | null): string => (v ? String(v).slice(0, 10) : '')

/**
 * Совпадает ли месяц/день дня рождения с today. Парсим строку без `new Date(iso)`,
 * чтобы не ловить таймзонные сдвиги (UTC-полночь могла бы съехать на соседний день).
 */
export const isBirthdayToday = (iso?: string | null, today: Date = new Date()): boolean => {
  if (!iso) return false
  const s = iso.slice(0, 10)
  if (!DATE_RE.test(s)) return false
  const month = Number(s.slice(5, 7))
  const day = Number(s.slice(8, 10))
  // ponytail: 29 Feb → показываем только в високосный год; праздновать 28-го — если попросят
  return month === today.getMonth() + 1 && day === today.getDate()
}
